import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {AggregatedAssetState} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state';

const initialState = {
  loading: true
};

export const AggregatedAssetStateStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withEntities<AggregatedAssetState>(),
  withMethods((store) => ({
    setAllEntities(states: AggregatedAssetState[]) {
      patchState(store, setAllEntities(states), { loading: false });
    },
    setEntity(state: AggregatedAssetState) {
      patchState(store, setEntity(state));
    },
    reset() {
      patchState(store, initialState);
    }
  }))
);
